import { render } from "./ImageInputComp.vue?vue&type=template&id=e60e1bf6&scoped=true&ts=true"
import script from "./ImageInputComp.vue?vue&type=script&lang=ts"
export * from "./ImageInputComp.vue?vue&type=script&lang=ts"

import "./ImageInputComp.vue?vue&type=style&index=0&id=e60e1bf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60e1bf6"]])

export default __exports__